import type { StepRenderProps } from "./types";
import { StatementStep } from "./StatementStep";
import { TextStep } from "./TextStep";
import { TextAreaStep } from "./TextAreaStep";
import { SingleChoiceStep } from "./SingleChoiceStep";
import { MultiChoiceStep } from "./MultiChoiceStep";
import { EmailStep } from "./EmailStep";
import { NumberStep } from "./NumberStep";
import { FileUploadStep } from "./FileUploadStep";
import { ReviewStep } from "./ReviewStep";

/** Maps a step config to its input renderer. Exhaustive over IntakeStepType. */
export function StepRenderer(props: StepRenderProps) {
  const { step } = props;
  switch (step.type) {
    case "statement":
      return <StatementStep {...props} step={step} />;
    case "text":
      return <TextStep {...props} step={step} />;
    case "textarea":
      return <TextAreaStep {...props} step={step} />;
    case "singleChoice":
      return <SingleChoiceStep {...props} step={step} />;
    case "multiChoice":
      return <MultiChoiceStep {...props} step={step} />;
    case "email":
      return <EmailStep {...props} step={step} />;
    case "number":
      return <NumberStep {...props} step={step} />;
    case "fileUpload":
      return <FileUploadStep {...props} step={step} />;
    case "review":
      return <ReviewStep {...props} step={step} />;
    default: {
      const _exhaustive: never = step;
      return _exhaustive;
    }
  }
}
